<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary" style="vertical-align: middle">access_time</v-icon> {{ $t('operadores.pendientes') }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :widthModal="800"
        >
          <template slot="buttons">

          </template>

          <template slot="items" slot-scope="items">
            <td class="nowrap">
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  @click.native="verCaso(items.item)">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <span>Ver detalles de caso</span>
              </v-tooltip>

              <v-tooltip bottom v-if="user.rol!=='ADMIN'">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="conversar(items.item.id)">
                  <v-icon>chat</v-icon>
                </v-btn>
                <span>{{$t('operadores.ingresar')}}</span>
              </v-tooltip>
            </td>
            <td>{{ items.item.tipo }}</td>
            <td>
              {{ items.item.persona }}
              <div style="font-size: 12px;">
                <img :src="imagenCanal(items.item.canal_principal.principal.clasificacion)" class="icono-canal" align="left"/>
                &nbsp;{{items.item.canal_principal.principal.usuario}}
              </div>
            </td>
            <td>{{ items.item.descripcion }}<div style="font-size: 12px;">{{items.item.punto_atencion}}</div></td>
            <td>
              <v-icon small :color="direccionColor(items.item)">{{direccionContenido(items.item)}}</v-icon>
              <v-tooltip bottom v-if="items.item['ultimoMensaje.tipo_contenido'] === 'texto'">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ `${items.item['ultimoMensaje.contenido'].substring(0, 40)} ${items.item['ultimoMensaje.contenido'].length > 40 ? '...' : ''}` }}</span>
                </template>
                <span>{{ items.item['ultimoMensaje.contenido'] }}</span>
              </v-tooltip>
              <span v-if="items.item['ultimoMensaje.tipo_contenido'] !== 'texto'">{{ formatoContenido(items.item) }}</span>
            </td>
            <td>{{ items.item._updated_at ? formato(items.item._updated_at) : formato(items.item._created_at) }}</td>
            <td>
              <v-chip label color="success" text-color="white" v-if="items.item.estado == 'PENDIENTE'">
                <strong>{{ items.item.estado }}</strong>&nbsp;
                <span>hace {{ obtenerDiasPendiente(items.item._created_at) }} día(s)</span>
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'CERRADO'">
                <strong>{{ items.item.estado }}</strong>&nbsp;
                <span>en {{ obtenerDias(items.item._created_at, items.item._updated_at) }} día(s)</span>
              </v-chip>
            </td>
          </template>
        </crud-table>
        <v-dialog :key="dialogKey" v-model="dialog" max-width="700">
          <v-card>
            <v-card-title class="headline m-0">
              <v-flex xs9>
                <v-icon>remove_red_eye</v-icon> Información adicional de caso
              </v-flex>
              <v-flex xs2 text-md-right>
                <v-chip label color="success" text-color="white" v-if="caso.estado == 'ACTIVO' || caso.estado == 'PENDIENTE'">
                  {{ caso.estado }}
                </v-chip>
                <v-chip label color="warning" text-color="white" v-if="caso.estado == 'CANCELADO'">
                  {{ caso.estado }}
                </v-chip>
                <v-chip label color="#bbb" text-color="white" v-if="caso.estado == 'CERRADO'">
                  {{ caso.estado }}
                </v-chip>
              </v-flex>
              <v-flex xs1 text-md-right>
                <v-btn small flat icon @click.native="dialog = false">
                  <v-icon class="red--text">cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <strong>Descripción del caso</strong>
                  <v-card flat>
                    <v-card-text>
                      {{ caso.descripcion }}
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-if="caso['tramite.nombre_tramite']">
                  <strong>Trámite</strong>
                  <p>{{ caso['tramite.nombre_tramite'] }}</p>
                </v-flex>
                <v-flex xs12>
                  <strong>Fecha de apertura</strong>
                  <v-chip :ripple="false">{{ formato(caso._created_at) }}</v-chip>
                </v-flex>
                <v-flex xs12 v-if="caso._updated_at && caso.estado!=='CERRADO'">
                  <strong>Última actividad</strong>
                  <v-chip :ripple="false">{{ formato(caso._updated_at) }}</v-chip>
                </v-flex>
                <v-flex xs12 v-if="caso.estado === 'CERRADO'">
                  <strong>Fecha de cierre</strong>
                  <v-chip :ripple="false">{{ formato(caso._updated_at) }}</v-chip>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <strong>Datos del solicitante</strong>
                </v-flex>
                <v-flex xs12 v-if="caso.id_persona">
                  Nombre:
                  <v-chip :ripple="false">{{ `${caso.persona}` }}</v-chip>
                </v-flex>
                <v-flex xs6 v-if="caso['persona.telefono']">
                  Teléfono:
                  <v-chip :ripple="false">{{ caso['persona.telefono'] }}</v-chip>
                </v-flex>
                <v-flex xs6 v-if="caso['persona.movil']">
                  Celular:
                  <v-chip :ripple="false">{{ caso['persona.movil'] }}</v-chip>
                </v-flex>
                <v-flex xs12>
                  Fuentes asociadas:
                  <v-chip v-for="canal in caso.canales" :key="canal.usuario">
                    Identificador: {{ `${canal.usuario}` }} Tipo: {{ `${canal.clasificacion}` }} 
                  </v-chip>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="red"
                @click.native="dialog = false">
                <v-icon>close</v-icon> {{ $t('common.close') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';
import LogDatos from '@/components/admin/usuario/LogDatos';
import logDatos from '@/components/admin/usuario/mixins/log-datos';
import moment from 'moment';

export default {
  mixins: [ crud, validate, token, logDatos ],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
  },
  mounted () {
    if (!this.$store.state.cubiculo.id) {
      if (this.$store.state.user.rol === 'ADMIN') {
        this.$store.state.cubiculo.id = 0;
      } else {
        this.$message.error(`${this.$t('operadores.cubiculo.requerido')}`, null, { timeout: 2000 });
        this.$router.push(`/operadores`);
      }
    }
  },
  data () {
    return {
      logDatos: null,
      successAlert: false,
      graphql: false,
      url: `system/operadores/${this.$store.state.cubiculo.id}/pendientes`,
      headers: [
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('operadores.crud.tipo'), value: 'tipo' },
        { text: this.$t('operadores.crud.persona'), value: 'persona' },
        { text: this.$t('operadores.crud.descripcion'), value: 'descripcion', sortable: false },
        { text: this.$t('caso.crud.ultimo_mensaje'), value: 'ultimoMensaje.contenido' },
        { text: this.$t('caso.crud.ultima_actualizacion'), value: '_updated_at' },
        { text: this.$t('common.status'), value: 'estado' }
      ],
      filters: [
        {
          field: 'tipo',
          label: this.$t('operadores.crud.tipo'),
          type: 'select',
          typeG: 'String',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'SIMPLE', text: 'SIMPLE' },
            { value: 'COMPLEJO', text: 'COMPLEJO' }
          ]
        },
        {
          field: 'descripcion',
          label: this.$t('operadores.crud.descripcion'),
          type: 'text',
          typeG: 'String'
        }
        // {
        //   field: 'estado',
        //   label: this.$t('common.status'),
        //   type: 'select',
        //   typeG: 'EstadoEntidad',
        //   items: [
        //     { value: '', text: 'TODOS' },
        //     { value: 'PENDIENTE', text: 'PENDIENTE' }
        //   ]
        // }
      ],
      idEntidad: null,
      valid: true,
      cubiculos: [],
      seleccion: 0,
      loading: false,
      caso: {},
      dialogKey: 'dialogo-caso',
      dialog: false
    };
  },
  methods: {
    imagenCanal (clasificacion) {
      let imagen = 'call.png';
      switch (clasificacion) {
        case 'whatsapp':
          imagen = 'wp.png';
          break;
        case 'facebook':
          imagen = 'fb.png';
          break;
        case 'twitter':
          imagen = 'tw.png';
          break;
        case 'correo':
          imagen = 'mail.png';
          break;
      }
      return require('@/assets/images/' + imagen);
    },
    verCaso (data) {
      this.caso = Object.assign({}, data);
      this.dialogKey = 'dialogCasoKey' + Math.random().toString(36).substr(2, 5);
      this.dialog = true;
    },
    formatoContenido (item) {
      let contenidoParams = item['ultimoMensaje.contenido'].split('/');
      let i = contenidoParams.length;
      if (i > 0) {
        return `${item['ultimoMensaje.tipo_contenido']} ${contenidoParams[i - 1]}`;
      } else {
        return `${item['ultimoMensaje.tipo_contenido']} ${item['ultimoMensaje.contenido']}`;
      }
    },
    direccionContenido (item) {
      let icono = 'priority_high';
      switch (item[`ultimoMensaje.direccion`]) {
        case 'ENTRADA':
          icono = 'arrow_back';
          break;
        case 'SALIDA':
          icono = 'arrow_forward';
          break;
      }
      return icono;
    },
    direccionColor (item) {
      let icono = 'default';
      switch (item[`ultimoMensaje.direccion`]) {
        case 'ENTRADA':
          icono = 'red';
          break;
        case 'SALIDA':
          icono = 'green';
          break;
      }
      return icono;
    },
    formato (fecha) {
      moment.locale('es');
      return moment(fecha).format('LLLL');
    },
    conversar (id) {
      this.ingresar(this.$store.state.cubiculo.id, id);
    },
    ingresar (id, conversacion) {
      this.recuperarCaso(id, conversacion);
    },
    recuperarCaso (cubiculo, conversacion) {
      this.$loading.show('Buscando canal...');
      this.loading = true;
      if (conversacion) {
        this.$service.get(`system/operadores/caso/${conversacion}/mensajes`, {})
        .then(response => {
          this.loading = false;
          let canal = 0;
          if (response && response.rows) {
            canal = response.rows[0].id_canal_entrada;
          }
          this.$router.push(`/conversacion/${cubiculo}/${canal}`);
        });
      }
    },
    obtenerDias (fechaInicio, fechaFin) {
      let dias = 1;
      if (fechaFin) {
        let fecha1 = moment(fechaInicio);
        let fecha2 = moment(fechaFin);
        dias = fecha2.diff(fecha1, 'days') + 1;
      }
      return dias;
    },
    obtenerDiasPendiente (fechaInicio) {
      let hoy = new Date();
      let fecha1 = moment(fechaInicio);
      let fecha2 = moment(hoy);
      let dias = fecha2.diff(fecha1, 'days');
      return dias;
    }
  },
  components: {
    CrudTable,
    LogDatos
  }
};
</script>
<style src="./chat.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/operadores/Pendientes.vue